document.addEventListener("alpine:init", () => {
  Alpine.store("stopScroll", {
    body: document.body,
    enable() {
      this.body.classList.add("body-lock");
    },
    disable() {
      if (
        !document.documentElement.classList.contains(
          "prescription-popup-opened"
        )
      ) {
        this.body.classList.remove("body-lock");
      }
    },
  });

  Alpine.store("popup", {
    visible: false,
    contentId: "",
    //popup key required
    show({ contentId } = {}) {
      this.visible = true;
      this.contentId = contentId;
      Alpine.store("stopScroll").enable();
    },
    hide() {
      this.visible = false;
      this.contentId = "";
      Alpine.store("stopScroll").disable();
    },
  });
});
